import { styled } from '@mui/material/styles';
import Table from 'components/PlacementsTable';

export const PlacementsTable = styled(Table)(({ theme }) => ({
  borderRadius: theme.borderRadius.base,
  boxShadow: theme.boxShadow.base
}));
